// NewBadge.jsx
import React from "react";

/**
 * 「New」 표식 — 등록 30일 이내.
 *
 * 상품 카드와 할랄맵 지점이 같은 뱃지를 쓴다. 서버도 창을 한 곳
 * (HasNewBadge, 30일)에 두고 `is_new` 로 내려주므로 두 화면에서 같은 것이
 * 같은 기간 동안 보인다 — 예전엔 지점이 「이번 달 등재」라 8월 31일 등재분이
 * 지도에선 하루 만에 New 를 잃었다. 앱(NewBadge)과도 같은 문구·같은 색.
 */
export default function NewBadge() {
  return (
    <span className="shrink-0 rounded bg-rose-50 px-1.5 py-0.5 text-[10px] font-semibold text-rose-600">
      New
    </span>
  );
}
